module.exports = __webpack_public_path__ + "./fonts/DMSans-Italic.8f02c1.eot";